/* eslint-disable no-useless-escape */
import axios from 'axios';
import React, { useEffect, useRef, useState } from 'react';
import { useFormContext, UseFormRegisterReturn, useWatch } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { actions } from '../../../features/quote/QuoteSlice';
import { Field } from '../../../types';
import Tooltip from '../Tooltip';

export interface CompanyLookupProps {
    field: Field;
    error?: string;
    inputRef: UseFormRegisterReturn;
    setError: (errMsg: string) => void;
}
function CompanyLookup(props: CompanyLookupProps) {
  const dispatch = useDispatch();
  const {
    getValues,
    setValue,
    trigger,
  } = useFormContext();
  const [company, setCompany] : [any, any] = useState();
  const {
    field, error, inputRef, setError,
  } = props;
  const watchFieldArray = useWatch({ name: 'quote' });
  const watchedCompanyCheckbox = watchFieldArray.find(
    (quote: any) => quote.formId === 'company_reg_address_is_correspondence_address',
  );
  const useCompanyReg = watchedCompanyCheckbox && watchedCompanyCheckbox.value;

  const getCompanyNumber = (event: any) => {
    dispatch(actions.setIsLoading(true));
    axios.get(`/KPS_TOOLS/cr_number_lookup.inc?cr_number=${getValues(inputRef.name)}`)
      .then((response) => {
        if (Object.prototype.hasOwnProperty.call(response.data, 'status')
        && response.data.status === 'success') {
          dispatch(actions.setIsLoading(false));
          setCompany(response.data.data);
          return Promise.resolve();
        }
        dispatch(actions.setIsLoading(false));
        return Promise.reject(new Error('could not find company'));
      })
      .catch((err: any) => {
        dispatch(actions.setIsLoading(false));
        setCompany(null);
        setError('Company could not be found, please check the number and try again');
      });
    event.preventDefault();
  };

  useEffect(() => {
    const values = getValues();
    values.quote.forEach((quote: any, index: number, valArray: any[]) => {
      // always use lookup to set business name
      if (quote.formId === 'business_name' && company) {
        setValue(
          `quote.${index}.value`,
          (company.company_name),
        );
      }
      if (!(company)) return;
      if (quote.formId === 'frm_personal_address1' || quote.formId === 'company_reg_address1') {
        setValue(
          `quote.${index}.value`,
          useCompanyReg || quote.formId.indexOf('company_') > -1 ? company.registered_office_address?.address_line_1 : '',
        );
        if (useCompanyReg) {
          trigger(`quote.${index}.value`);
        }
      }
      if (quote.formId === 'frm_personal_address2' || quote.formId === 'company_reg_address2') {
        setValue(`quote.${index}.value`, useCompanyReg || quote.formId.indexOf('company_') > -1
          ? company.registered_office_address?.address_line_2 : '');

        if (useCompanyReg) {
          trigger(`quote.${index}.value`);
        }
      }
      if (quote.formId === 'frm_personal_address3' || quote.formId === 'company_reg_address3') {
        setValue(
          `quote.${index}.value`,
          useCompanyReg || quote.formId.indexOf('company_') > -1 ? company.registered_office_address?.locality : '',
        );
        if (useCompanyReg) {
          trigger(`quote.${index}.value`);
        }
      }
      if (quote.formId === 'frm_personal_address4' || quote.formId === 'company_reg_address4') {
        setValue(
          `quote.${index}.value`,
          useCompanyReg || quote.formId.indexOf('company_') > -1 ? company.registered_office_address?.region : '',
        );
        if (useCompanyReg) {
          trigger(`quote.${index}.value`);
        }
      }
      if (quote.formId === 'frm_personal_country_code' || quote.formId === 'company_reg_country') {
        setValue(
          `quote.${index}.value`,
          useCompanyReg || quote.formId.indexOf('company_') > -1 ? 'GB' : '',
        );
        if (useCompanyReg) {
          trigger(`quote.${index}.value`);
        }
      }
      if (quote.formId === 'frm_personal_postcode' || quote.formId === 'company_reg_postcode') {
        setValue(
          `quote.${index}.value`,
          useCompanyReg || quote.formId.indexOf('company_') > -1 ? company.registered_office_address?.postal_code : '',
        );
        if (useCompanyReg) {
          trigger(`quote.${index}.value`);
        }
      }
    });
    dispatch(actions.updateQuote(getValues()));
    if (useCompanyReg && company) trigger('quote');
  }, [company, useCompanyReg]);

  return (
    <>
      <div className={`mb-4 form-card p-4 ${error ? 'error' : ''}`}>
        <label htmlFor={field.id} className="form-label my-2">
          {field.label}
          {field.required
            && <span className="ms-2 d-inline-block asterix">*</span>}
        </label>
        <input id={field.formId} {...inputRef} key={field.id} type="text" className="form-control my-2" />
        <button disabled={!!error} type="button" className="my-2" onClick={getCompanyNumber}>Find Company</button>
        <div className="form-card-footer d-flex justify-content-between">
          {
            error
            && <small className="error" dangerouslySetInnerHTML={{ __html: error }} />
          }
          {field.tooltip && <Tooltip tooltipText={field.tooltip} />}
        </div>
      </div>
      {
        company
        && (
        <div className="mb-4">
          <p className="terms ps-2 kb-border-start">
            {company.company_name}
            <br />
            {company.registered_office_address.address_line_1}
            <br />
            {company.registered_office_address.address_line_2}
            <br />
            {company.registered_office_address.locality}
            <br />
            {company.registered_office_address.region}
            <br />
            {company.registered_office_address.postal_code}
          </p>
        </div>
        )
      }
    </>
  );
}
CompanyLookup.defaultProps = {
  error: false,
};
export default CompanyLookup;
